import './index.less';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ImageRotator = ({ images, interval, transition }) => {
  const { t } = useTranslation();
  const [currentCarouselIndex, setCarouselIndex] = useState(0);
  const carouselLength = images.length;

  useEffect(() => {
    const i = setInterval(() => {
      setCarouselIndex((currentCarouselIndex) => {
        const newIndex = currentCarouselIndex + 1 >= carouselLength ? 0 : currentCarouselIndex + 1;
        return newIndex;
      });
    }, interval || 5000);
    return () => clearInterval(i);
  }, [currentCarouselIndex]);

  const carousel = images.map((element, index) => (
    <img
      key={index}
      className={currentCarouselIndex === index ? 'active' : 'inactive'}
      src={element}
      transitionDelay={transition ? `${transition / 1000}s` : '3s'}
    />
  ));

  return <div className="image-rotator-container">{carousel}</div>;
};

export default ImageRotator;
